import styles from "./index.module.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Masha from "./Card.png";
import mic from "./mic.png";
import monkey from "./monkey.png";
import calendar from "./calendar.png";

export default function DescriptionBLock() {
  const { ref, inView } = useInView({
    triggerOnce: true, // запускається лише один раз
    threshold: 0.5, // 50% елементу має бути видимим
  });
  return (
    <div data-aos={"fade-up"}>
      <div className={styles.container}>
        <div className={styles.description}>
          <img src={Masha} alt={"description"} />
          <div className={styles.text}>
            <h2>
              Страх — <br />
              не твоя вина
            </h2>
            <div>
              Страх помилитися — це наслідок совкової системи, а не твоя
              проблема. Profound це виправить! Ми пофіксимо твої страхи і
              зробимо з тебе chitchatter.{" "}
            </div>
            <h2 className={styles.grey}>
              Практика, а не
              <br />
              зубріння
            </h2>
            <h2 className={styles.grey + " " + styles.hidem}>
              «Bye, sorry for my
              <br /> English»
            </h2>
          </div>
        </div>
      </div>
      <div className={styles.statsBlock} ref={ref}>
        {inView && (
          <div className={styles.stats}>
            <div>
              <h1>3x</h1>
              <div>
                в 3 рази швидше
                <br /> звичайної програми
              </div>
            </div>
            <div>
              <h1>
                <CountUp duration={4} end={52} start={0} />
              </h1>
              <div>
                уроки
                <br /> за інтенсив
              </div>
            </div>
            <div>
              <h1>
                <CountUp duration={4} end={12} start={0} />
              </h1>
              <div>
                різних
                <br /> спеціалістів
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={styles.widgetContainer}>
        <h1 className={styles.titleAbout}>Про інтенсив</h1>
        <div className={styles.widgets}>
          <div className={styles.widget}>
            <img src={mic} alt={"mic"} />
            <h3>
              Фокус на граматиці,
              <br />
              лексиці та говорінні
            </h3>
          </div>
          <div className={styles.widget}>
            <img src={monkey} alt={"monkey"} />
            <h3>
              Communicative
              <br />
              eclectic approach
            </h3>
          </div>
          <div className={styles.widget}>
            <img src={calendar} alt={"calendar"} />
            <h3>
              3 місяці навчання,
              <br />4 заняття на тиждень
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
